/* eslint-disable */

import { FC, useState } from 'react';
import {
  // ActionIcon,
  TDropdown,
  ThreeDotsDropdown,
  Tooltip,
  Typography,
  TDropdownOptions,
  ProfilePicture,
  ActionIcon,
  ConfirmModal
} from 'src/components/common';
import { colors } from 'src/constants';
import { textEllipsis } from 'src/utils';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { useToggleCreateEditGroupModal, useToggleManageGroupModalModal } from 'src/components/chat';
import { useGetIdentity, useToggleOpenModal } from 'src/hooks';
import './ideaDiscussionGroupHeader.scss';
import { TIdeaDiscussionGroupHeaderProps } from './ideaDiscussionGroupHeader.types';
import useToggleOpenDiscussionMembersModal from './useToggleOpenDiscussionMembersModal';

import EditIdeaGroup from '../../editIdeaGroup/EditIdeaGroup';
import { TIdeaSharedWithMe } from 'src/components/ideaHub/ideaHub.types';
import { groupicon } from 'src/assets/images';
import { SingleChevronIcon } from 'src/components/common/common.icons';
import { useNavigate } from 'react-router-dom';
import { getGroups, removeUserFromGroup } from 'src/store/chat/chat.slice';
import Discussion from '../../Discussion';

const IdeaDiscussionGroupHeader: FC<TIdeaDiscussionGroupHeaderProps> = ({
  discussionType,
  groupId,
  ideaId
  // isViewerOwner
}: TIdeaDiscussionGroupHeaderProps) => {
  // Hooks
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { getIdentities } = useGetIdentity();
  const { Groups, GroupParticipants } = useAppSelector((store) => store.chat);
  const currentModalId = useAppSelector((store) => store.common.modalId);
  const toggleOpenModal = useToggleOpenModal();
  const { toggleCreateEditGroupModal, isToggleCreateEditGroupModalOpen } =
  useToggleCreateEditGroupModal({ mode: 'Edit' });
  
  // state 
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState<boolean>(false)
  
  // constant 
  const deleteProgramGroupConfirmModalId = `deleteProgramGroupConfirmModal-${groupId}`;
  const isDeleteGroupModalOpen = currentModalId === deleteProgramGroupConfirmModalId
  const { authenticatedId, loggedInUserType } = getIdentities();
  const toggleOpenDeleteGroupModal = () => {
    toggleOpenModal({ modalId: deleteProgramGroupConfirmModalId });
  };
  let headerDropdownOptions: TDropdownOptions[] = [];

  if (GroupParticipants?.[0]?.ownerId === authenticatedId) {
    headerDropdownOptions =
      // { label: 'Manage Members', onClick: toggleManageGroupModalModal },
      [
        { label: 'Edit Group Details', onClick: toggleCreateEditGroupModal },
        { label: 'Delete Group', onClick: toggleOpenDeleteGroupModal }
      ];
  } else {
    headerDropdownOptions =
      // { label: 'Manage Members', onClick: toggleManageGroupModalModal },
      // { label: 'Edit Group Details', onClick: toggleCreateEditGroupModal },
      [{ label: 'Leave Group', onClick: handleLeaveGroup }];
  }
  const ideaGroupParticipants: any = useAppSelector((store) => store.chat.GroupParticipants);
  const ideasSharedWithMe: TIdeaSharedWithMe[] = useAppSelector(
    (store) => store.ideaHub.ideasSharedWithMe
  );

  const { toggleOpenOpenDiscussionMembersModal } = useToggleOpenDiscussionMembersModal();
  function handleLeaveGroup() {
    setIsConfirmationModalOpen(true)
  }
  // Constants
  // const participants: any = [
  //   ...ideaGroupParticipants?.[0]?.Users,
  //   ...ideaGroupParticipants?.[0]?.Companies
  // ];
  const groupName = ideaGroupParticipants?.[0]?.groupName;
  const participants = ideaGroupParticipants?.[0]?.Users;
  const ownerName: any =
    ideasSharedWithMe?.find(
      (item: TIdeaSharedWithMe) => item?.idea?.id === ideaGroupParticipants?.[0]?.ideaId
    )?.idea?.owner || '';
  const ownerNameWitEllipsis = textEllipsis({ text: ownerName?.name, charLimit: 12 });

  const dropdownOptionsProps: TDropdown = {
    id: `chat-messages-header-${groupId}`,
    size: 'large',
    alignment: 'center',
    items: headerDropdownOptions
  };
  const filterParticipant = participants
    // ?.filter((item: any) => item?.id !== ownerName?.id)
    ?.map((item: any) => item?.name);
  let membersToRender: string[] = [];
  const remainingMembers: number = filterParticipant?.length - 7;
  try {
    if (participants?.length > 7) {
      for (let i = 1; i < 7; i++) {
        const member = filterParticipant?.[i];
        console.log(member, 'memberrr');
        membersToRender.push(member);
      }
    } else {
      membersToRender = filterParticipant?.slice(0)?.map((member: any) => member);
    }
  } catch { }
  const openMembersModal = () => {
    if (discussionType === 'programDiscussion') {
      toggleOpenOpenDiscussionMembersModal();
    }
  };
  function handleConfirm() {
    dispatch(removeUserFromGroup({ userId: authenticatedId, conversationId: groupId })).then((response) => {
      const payload: any = {
        userId: authenticatedId,
        userType: loggedInUserType
      };

      dispatch(getGroups(payload));
      setTimeout(() => {
        navigate('/chat')
      }, 1000)
    })
  }
  const closeChatWindow = (e) => {
    e?.preventDefault()
    e?.stopPropagation()
    navigate('/chat');
  };

  return (
    <>
    {isDeleteGroupModalOpen && <Discussion />}
      <ConfirmModal
        title="Are you sure you want to leave from this group"
        openConfirmModal={isConfirmationModalOpen}
        onClose={() => setIsConfirmationModalOpen(false)}
        onSubmit={handleConfirm}
        submitText="Confirm"
        type="error"
      />
      <div className="discussion-messages-header">
        <div className="discussion-messages-header__left">
          <div className='discussion-messages-header__left__group-header-box'>
            <ActionIcon
              onClick={closeChatWindow}
              className="chat-messages-header__left__go-back-mobile"
            >
              <SingleChevronIcon direction="left" />
            </ActionIcon>
            <ProfilePicture url={groupicon} fallback={'group'} />
            <div className='discussion-messages-header__left__group-header-box__content-Box'>
              <Typography
                as="p"
                variant="body-1"
                fontWeight="semiBold"
                style={{ color: colors?.neutral?.[1100] }}
                className="discussion-messages-header__left__heading"
              >
                {discussionType === 'programDiscussion' ? 'Program Discussion' : groupName}
              </Typography>
              {/* {(!membersToRender ||
              membersToRender?.length === 0) && <span>Group</span>} */}
              <div className="discussion-messages-header__left__members mt-2">
                {ownerNameWitEllipsis?.text && (
                  <Tooltip
                    key={'owner'}
                    text={ownerName?.name}
                    conditionToDisplay={ownerNameWitEllipsis?.hasEllipsis}
                    limitWidth
                  >
                    <Typography
                      as="p"
                      variant="caption"
                      fontWeight="regular"
                      style={{ color: colors?.neutral?.[1100] }}
                    >
                      {ownerNameWitEllipsis?.text}&nbsp;(Owner),&nbsp;
                    </Typography>
                  </Tooltip>
                )}
                {membersToRender &&
                  membersToRender?.length > 0 &&
                  membersToRender.map((member, index) => {
                    const nameWitEllipsis = textEllipsis({ text: member, charLimit: 12 });
                    return (
                      <Tooltip
                        key={index}
                        text={member}
                        conditionToDisplay={nameWitEllipsis?.hasEllipsis}
                        limitWidth
                      >
                        <Typography
                          as="p"
                          variant="caption"
                          fontWeight="regular"
                          style={{ color: colors?.neutral?.[1100], whiteSpace: 'nowrap' }}
                        >
                          {nameWitEllipsis?.text},&nbsp;
                        </Typography>
                      </Tooltip>
                    );
                  })}
                {remainingMembers > 0 && (
                  <Typography
                    as="p"
                    variant="caption"
                    fontWeight="semiBold"
                    style={{ color: colors?.neutral?.[1100] }}
                    className="discussion-messages-header__left__members__more-users"
                    onClick={openMembersModal}
                  >
                    +{remainingMembers}&nbsp;more users
                  </Typography>
                )}
              </div>
            </div>
          </div>

        </div>
        {/* {isViewerOwner && ( */}
        <div className="discussion-messages-header__right">
          <ThreeDotsDropdown dropdownOptions={dropdownOptionsProps} />
        </div>
        {/* )} */}

        {isToggleCreateEditGroupModalOpen && (
          <EditIdeaGroup
            mode="Edit"
            isModalOpen={isToggleCreateEditGroupModalOpen}
            onModalClose={toggleCreateEditGroupModal}
            groupId={groupId}
            userId={authenticatedId}
            userType={loggedInUserType}
            groupMembers={ideaGroupParticipants?.[0]}
            ideaId={ideaId}
            groupName={groupName || ''}
          />
        )}
      </div>
    </>
  );
};

export default IdeaDiscussionGroupHeader;
